import React from 'react'
import { find, sortBy } from 'lodash'
import { makeStyles, Grid } from '@material-ui/core'

import { useDispatch, useSelector } from 'react-redux'
import Autocomplete from '~/components/Autocomplete'
import { Creators as AccessProfileActions } from '~/store/ducks/accessProfile'
import styles from './styles'

const rolesFilterSelector = ({ accessProfile }) => accessProfile.roles
const accessProfileSelector = ({ accessProfile }) => accessProfile
const useStyles = makeStyles(styles)

function AccessProfileFilters() {
  const { options } = useSelector(accessProfileSelector)
  const classes = useStyles()
  const dispatch = useDispatch()
  const { data: rolesFilter, loading: loadingRolesFilter } = useSelector(rolesFilterSelector)

  const handlePropertyFilterChange = (property, value) => {
    dispatch(AccessProfileActions.setAccessProfilePropertyFilter(property, value))
  }

  const getFilterValue = (property) => {
    if (options.filters) {
      const filterValue = find(options.filters, { name: property })
      return filterValue ? filterValue.value : null
    }
    return null
  }

  return (
    <Grid container className={classes.gridContainerButton} spacing={2}>
      <Grid item xs={12} md={6}>
        <Autocomplete
          onChange={(_, option) => {
            handlePropertyFilterChange(
              'role_id',
              option ? option.value : null,
            )
          }}
          options={sortBy(rolesFilter, (a) => a.name).map((option) => ({
            label: option.display_name,
            value: option.id,
          }))}
          name="role_id"
          value={getFilterValue('role_id')}
          className={classes.autocomplete}
          label="Selecione um perfil de acesso"
          placeholder="Selecione um perfil de acesso"
          loading={loadingRolesFilter}
          autoSelect={false}
        />
      </Grid>
    </Grid>
  )
}

export default AccessProfileFilters
